import React, { useRef, useEffect, useState } from "react";
import HoverTooltip from "../hovertooltip/hovertooltip";
import { OverflowTooltipProps } from "./overflow-tooltip.props";
import "./overflow-tooltip.scss";

const OverflowTooltip = (props: OverflowTooltipProps) => {
  const { children, ignoreOverflow } = props;
  const [isOverflowing, setIsOverflowing] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      const childElement = containerRef.current.firstChild as HTMLElement;
      if (childElement && !isOverflowing) {
        setIsOverflowing(childElement.scrollWidth > childElement.clientWidth);
      }
    }
  }, [children, isOverflowing]);

  return (
    <div ref={containerRef} className="overflow-tooltip-wrapper">
      {isOverflowing || ignoreOverflow ? <HoverTooltip {...props}>{children}</HoverTooltip> : children}
    </div>
  );
};

export default OverflowTooltip;
